import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertMessagePayload, AlertService } from '../../service/alert.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert-message',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.css'
})
export class AlertMessageComponent implements OnInit, OnDestroy {

  private alertSubscription!: Subscription;
  private langChangeSubscription!: Subscription;
  message: AlertMessagePayload | null | undefined;
  renderedText: string = '';
  private timeoutId: any;

  @Input() iconStyle: { [klass: string]: any } = {};

  constructor(
    private alertService: AlertService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.alertSubscription = this.alertService.getMessage().subscribe(message => {
      this.message = message;
      this.refreshRenderedText();
      this.cdr.detectChanges();

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    });

    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      if (!this.message) {
        return;
      }

      this.refreshRenderedText();
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.alertSubscription?.unsubscribe();
    this.langChangeSubscription?.unsubscribe();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  close() {
    this.alertService.clear();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private refreshRenderedText(): void {
    if (!this.message) {
      this.renderedText = '';
      return;
    }

    if (this.message.i18nKey) {
      this.renderedText = this.translate.instant(this.message.i18nKey, this.message.i18nParams);
      return;
    }

    this.renderedText = this.message.text ?? '';
  }

}
